import { createContext, useMemo } from "react";

import { LoadingContent } from "../../components/SharedComponents/sharedComponents.index";
import { LOADING_CONTENT_TYPE } from "../../components/SharedComponents/LoadingContent/loading.content.constants";

import { useAuth } from "../AuthGate";

import PropTypes from "prop-types";

export const TenantContext = createContext();

export function TenantProvider({ children }) {
  const authUser = useAuth();

  const isLoading = !authUser?.tenant;

  const getHierarchyNames = (res) => {
    const hierarchyNames = { ...res.tenant };
    for (let key in hierarchyNames) {
      if (!key.includes("level")) delete hierarchyNames[key];
    }
    return {
      levels: Object.keys(hierarchyNames).sort((a, b) => a.localeCompare(b)),
      labels: hierarchyNames,
    };
  };

  const providerValue = useMemo(() => {
    if (!authUser?.tenant) return null;

    const unit = authUser.tenant?.unit;
    const tenant = authUser.tenant?.name;
    const username = authUser?.username;
    const hasProductOpportunities = Boolean(authUser.tenant?.productOpportunities);
    const hasChannelOpportunities = Boolean(authUser.tenant?.channelOpportunities);
    const hasAssortmentManagement = Boolean(authUser.tenant?.assortmentManagement);
    const hasAdjustmentPlan = Boolean(authUser.tenant?.adjustProductPlan);
    const hasPlanvsforecastAnalysis = Boolean(authUser.tenant?.planvsforecastAnalysis);
    const hasForecastAssertivity = Boolean(authUser.tenant?.forecastAssertivity);
    const hasOpportunityCheckout = Boolean(authUser.tenant?.opportunityCheckout);
    const hierarchy = getHierarchyNames(authUser);
    const tenantClass = authUser.tenant?.tenantClass;

    return {
      userInfo: authUser,
      hierarchy,
      unit,
      tenant,
      username,
      hasChannelOpportunities,
      hasAssortmentManagement,
      hasAdjustmentPlan,
      hasProductOpportunities,
      hasPlanvsforecastAnalysis,
      hasForecastAssertivity,
      hasOpportunityCheckout,
      tenantClass
    };
  }, [authUser]);

  return (
    <TenantContext.Provider value={providerValue}>
      {!isLoading ? (
        children
      ) : (
        <LoadingContent
          label={"Identificando seu perfil..."}
          type={LOADING_CONTENT_TYPE.SHARED_CONTEXT}
        />
      )}
    </TenantContext.Provider>
  );
}

TenantProvider.propTypes = {
  children: PropTypes.node.isRequired,
};